import { useEffect, useMemo, useRef, useState } from 'react'
import { useAuth } from '../../context/useAuth'
import { useWorkspace } from '../../context/useWorkspace'
import { recordProductAnalyticsEvent } from '../../services/productAnalyticsService'
import { deriveProductSectionFromPath } from './productSectionAnalytics'

const currentPath = () => {
  if (typeof window === 'undefined') return '/'
  return `${window.location.pathname}${window.location.search}${window.location.hash}`
}

export const ProductAnalyticsRouteBridge = () => {
  const { currentUser } = useAuth()
  const { activeWorkspaceId } = useWorkspace()
  const [path, setPath] = useState(currentPath)
  const lastRecordedRef = useRef('')
  const userId = currentUser?.uid ?? ''
  const section = useMemo(() => deriveProductSectionFromPath(path), [path])

  useEffect(() => {
    if (typeof window === 'undefined') return
    const notify = () => setPath(currentPath())
    const originalPush = window.history.pushState
    const originalReplace = window.history.replaceState
    window.history.pushState = function pushState(...args) {
      originalPush.apply(this, args)
      notify()
    }
    window.history.replaceState = function replaceState(...args) {
      originalReplace.apply(this, args)
      notify()
    }
    window.addEventListener('popstate', notify)
    window.addEventListener('hashchange', notify)
    return () => {
      window.history.pushState = originalPush
      window.history.replaceState = originalReplace
      window.removeEventListener('popstate', notify)
      window.removeEventListener('hashchange', notify)
    }
  }, [])

  useEffect(() => {
    if (!userId || !section) return
    const key = `${userId}:${activeWorkspaceId || 'none'}:${path}:${section.key}`
    if (lastRecordedRef.current === key) return
    lastRecordedRef.current = key
    void recordProductAnalyticsEvent({
      eventType: 'SECTION_OPENED',
      sectionKey: section.key,
      sectionLabel: section.label,
      workspaceId: activeWorkspaceId || null,
      route: path,
      surface: section.surface,
    }).catch((error) => {
      console.info('[ProductAnalyticsRouteBridge] analytics event skipped.', error)
    })
  }, [activeWorkspaceId, path, section, userId])

  return null
}

export default ProductAnalyticsRouteBridge
